import React, { Component } from 'react'
import { Button, Card } from '@softwaredev_cegeka/stix-core/dist/components'
import { Grid } from '@softwaredev_cegeka/stix-core'
import { CustomIcon } from 'src/components/CustomIcon'
import { Link } from 'react-router-dom'
import 'src/components/UnauthorizedCard/unauthorizedCard.scss'

class Logout extends Component {
    handleLogout = () => {
        window.location.href = '/sso-logout'
    }

    render() {
        return (
            <Grid.Row>
                <Grid.Col md={{ offset: 4, span: 4 }}>
                    <Card className={'unauthorized-card'}>
                        <Card.Body>
                            <CustomIcon icon={'unauthorized'} />
                            <div className={'unauthorized-content'}>
                                <Card.Title className={'unauthorized-title'}>
                                    Are you sure you want to logout?
                                </Card.Title>
                                <div>
                                    <Link to={'/'}>
                                        <Button
                                            variant={'outline-secondary'}
                                            style={{
                                                float: 'left',
                                                width: '45%',
                                            }}
                                        >
                                            No
                                        </Button>
                                    </Link>
                                    <Button
                                        variant={'outline-secondary'}
                                        style={{ float: 'right', width: '45%' }}
                                        onClick={this.handleLogout}
                                    >
                                        Yes
                                    </Button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Grid.Col>
            </Grid.Row>
        )
    }
}

export default Logout
